<template>
  <v-layout row wrap class="payment-container">
    <v-flex lg12>
      <v-tabs color="white" slider-color="primary" class="futuristic-tabs">
        <v-tab ripple key="residency" class="earth-color">RESIDENCY CONFIGURATION</v-tab>
        <v-tab ripple key="conservation" class="earth-color">CONSERVATION FEES</v-tab>
        <v-tab-item key="residency">
          <div class="row">
            <v-flex lg4 md12 sm12 xs12>
              <v-container>
                <v-card flat class="futuristic-card">
                  <div class="card-header">
                    <h4 class="earth-color">ADD A RESIDENCY CATEGORY</h4>
                    <div class="title-decoration"></div>
                  </div>
                  <v-container>
                    <v-form>
                      <v-text-field
                        label="Residency Person"
                        v-model="residency.person"
                        :rules="requiredRules"
                        required
                        class="futuristic-input"
                      ></v-text-field>
                      <v-select
                        label="Marker"
                        v-model="residency.marker"
                        :items="['Adult - A', 'Child - C', 'Infant - I']"
                        :rules="[(v) => !!v || 'Item is required']"
                        required
                        item-text="destination_name"
                        item-value="destination_public_id"
                        :loading="$loadingTrue"
                        class="futuristic-input"
                      ></v-select>
                      <v-select
                        label="Appears in school conservancy fees"
                        v-model="residency.school"
                        :items="['Yes', 'No']"
                        :rules="[(v) => !!v || 'Item is required']"
                        required
                        class="futuristic-input"
                      ></v-select>
                      <v-text-field
                        label="Max Number"
                        type="number"
                        v-model.number="residency.max_number"
                        :min="0"
                        :rules="requiredRules"
                        required
                        class="futuristic-input"
                      ></v-text-field>
                      <v-text-field
                        label="Income Account Code"
                        v-model="residency.income_account_code"
                        :rules="requiredRules"
                        required
                        class="futuristic-input"
                      ></v-text-field>
                      <v-text-field
                        label="Department Analysis"
                        v-model="residency.department_analysis_code"
                        :rules="requiredRules"
                        required
                        class="futuristic-input"
                      ></v-text-field>
                      <v-textarea
                        label="Description"
                        v-model="residency.description"
                        :rules="requiredRules"
                        required
                        type="text"
                        class="futuristic-input"
                      ></v-textarea>
                      <v-switch
                        label="Proof Residency"
                        color="primary"
                        v-model="residency.residency_proof"
                        required
                        class="futuristic-switch"
                      ></v-switch>
                      <v-btn
                        :depressed="true"
                        block
                        color="primary"
                        type="submit"
                        @click.prevent="postResidencyConf()"
                        v-if="edit === false"
                        class="futuristic-btn"
                      >Add Residency</v-btn>
                      <v-btn
                        :depressed="true"
                        block
                        color="warning"
                        type="submit"
                        @click.prevent="updateResidencyConf()"
                        v-if="edit === true"
                        class="futuristic-btn warning-btn"
                      >Update Residency</v-btn>
                    </v-form>
                  </v-container>
                </v-card>
              </v-container>
            </v-flex>
            <v-flex lg8>
              <v-container>
                <v-card class="futuristic-card">
                  <div class="card-header">
                    <h4 class="earth-color">RESIDENCY CATEGORIES</h4>
                    <div class="title-decoration"></div>
                  </div>
                  <v-data-table
                    :headers="residencyColumns"
                    :items="allFullConservationFees"
                    :search="search"
                    :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
                    :disable-initial-sort="true"
                    :loading="$loadingTrue"
                    class="futuristic-table"
                  >
                    <v-progress-linear
                      slot="progress"
                      color="#587e27"
                      indeterminate
                      height="3"
                    ></v-progress-linear>
                    <template slot="items" slot-scope="props">
                      <td class="fancy">{{ props.item.payment_person }}</td>
                      <td class="fancy">{{ props.item.marker }}</td>
                      <td class="fancy">{{ props.item.school }}</td>
                      <td class="fancy">{{ props.item.payment_person_income_code }}</td>
                      <td class="fancy">{{ props.item.payment_person_dept_code }}</td>
                      <td class="fancy">{{ props.item.residency_proof }}</td>
                      <td class="has-text-right">
                        <v-btn
                          :depressed="true"
                          small
                          color="warning"
                          @click="editResidency(props.item)"
                          v-if="edit === false"
                          class="futuristic-btn warning-btn action-btn"
                        >Edit</v-btn>
                        <v-btn
                          :depressed="true"
                          small
                          color="error"
                          @click="resetInputs2()"
                          v-if="edit === true"
                          class="futuristic-btn error-btn action-btn"
                        >Cancel Edit</v-btn>
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-container>
            </v-flex>
          </div>
        </v-tab-item>
        <v-tab-item key="conservation">
          <div class="row">
            <v-flex lg4 md12 sm12 xs12>
              <v-container>
                <v-card flat class="futuristic-card">
                  <div class="card-header">
                    <h4 class="earth-color">ADD CONSERVATION FEES</h4>
                    <div class="title-decoration"></div>
                  </div>
                  <v-container v-if="pricedSchedule === true">
                    <v-form>
                      <v-autocomplete
                        label="Select Currency"
                        v-model="update_.currency"
                        :items="allCurrencies"
                        :rules="[(v) => !!v || 'Item is required']"
                        required
                        item-text="currency_name"
                        item-value="currency_public_id"
                        :loading="$loadingTrue"
                        class="futuristic-input"
                      ></v-autocomplete>
                      <v-text-field
                        label="Amount"
                        type="number"
                        v-model="update_.amount"
                        :rules="requiredRules"
                        required
                        class="futuristic-input"
                      ></v-text-field>
                      <v-btn
                        @click.prevent="postEditedPricingSchedule()"
                        :depressed="true"
                        block
                        color="warning"
                        type="submit"
                        class="futuristic-btn warning-btn"
                      >Update Pricing</v-btn>
                    </v-form>
                  </v-container>
                  <v-container v-if="pricedConservationSchedule === true">
                    <v-form>
                      <v-dialog
                        ref="dialog"
                        persistent
                        v-model="modal1"
                        lazy
                        full-width
                        width="290px"
                        :return-value.sync="scheduleUpdate.start_date"
                      >
                        <v-text-field
                          slot="activator"
                          label="Start Date"
                          v-model="scheduleUpdate.start_date"
                          readonly
                          class="futuristic-input"
                        ></v-text-field>
                        <v-date-picker
                          v-model="scheduleUpdate.start_date"
                          :min="start_date"
                          scrollable
                          class="futuristic-date-picker"
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="modal1 = false"
                            class="futuristic-btn"
                          >Cancel</v-btn>
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="$refs.dialog.save(scheduleUpdate.start_date)"
                            class="futuristic-btn"
                          >OK</v-btn>
                        </v-date-picker>
                      </v-dialog>
                      <v-dialog
                        ref="dialog1"
                        persistent
                        v-model="modal2"
                        lazy
                        full-width
                        width="290px"
                        :return-value.sync="scheduleUpdate.end_date"
                      >
                        <v-text-field
                          slot="activator"
                          label="End Date"
                          v-model="scheduleUpdate.end_date"
                          readonly
                          class="futuristic-input"
                        ></v-text-field>
                        <v-date-picker
                          v-model="scheduleUpdate.end_date"
                          :min="scheduleUpdate.start_date"
                          scrollable
                          class="futuristic-date-picker"
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="modal2 = false"
                            class="futuristic-btn"
                          >Cancel</v-btn>
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="$refs.dialog1.save(scheduleUpdate.end_date)"
                            class="futuristic-btn"
                          >OK</v-btn>
                        </v-date-picker>
                      </v-dialog>
                      <v-autocomplete
                        label="Select Destination"
                        v-model="scheduleUpdate.destination"
                        :items="allDestinations"
                        item-text="destination_name"
                        item-value="destination_public_id"
                        :loading="$loadingTrue"
                        class="futuristic-input"
                      ></v-autocomplete>
                      <v-btn
                        @click.prevent="postEditedConservationSchedule()"
                        :depressed="true"
                        color="warning"
                        type="submit"
                        class="futuristic-btn warning-btn"
                      >Update Schedule</v-btn>
                    </v-form>
                  </v-container>
                  <v-container v-if="pricedSchedule === false && pricedConservationSchedule === false">
                    <v-form>
                      <v-dialog
                        ref="dialog"
                        persistent
                        v-model="modal1"
                        lazy
                        full-width
                        width="290px"
                        :return-value.sync="conservation_fee.start_date"
                      >
                        <v-text-field
                          slot="activator"
                          label="Schedule Start Date"
                          v-model="conservation_fee.start_date"
                          readonly
                          class="futuristic-input"
                        ></v-text-field>
                        <v-date-picker
                          v-model="conservation_fee.start_date"
                          :min="start_date"
                          scrollable
                          class="futuristic-date-picker"
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="modal1 = false"
                            class="futuristic-btn"
                          >Cancel</v-btn>
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="$refs.dialog.save(conservation_fee.start_date)"
                            class="futuristic-btn"
                          >OK</v-btn>
                        </v-date-picker>
                      </v-dialog>
                      <v-dialog
                        ref="dialog1"
                        persistent
                        v-model="modal2"
                        lazy
                        full-width
                        width="290px"
                        :return-value.sync="conservation_fee.end_date"
                      >
                        <v-text-field
                          slot="activator"
                          label="Schedule End Date"
                          v-model="conservation_fee.end_date"
                          readonly
                          class="futuristic-input"
                        ></v-text-field>
                        <v-date-picker
                          v-model="conservation_fee.end_date"
                          :min="conservation_fee.start_date"
                          scrollable
                          class="futuristic-date-picker"
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="modal2 = false"
                            class="futuristic-btn"
                          >Cancel</v-btn>
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="$refs.dialog1.save(conservation_fee.end_date)"
                            class="futuristic-btn"
                          >OK</v-btn>
                        </v-date-picker>
                      </v-dialog>
                      <v-autocomplete
                        label="Select Destination (Not Mandatory)"
                        v-model="conservation_fee.destination_details"
                        :items="allDestinations"
                        item-text="destination_name"
                        item-value="destination_public_id"
                        :return-object="true"
                        :loading="$loadingTrue"
                        class="futuristic-input"
                      ></v-autocomplete>
                      <v-autocomplete
                        label="Select Residency Type"
                        v-model="group.person_details"
                        :items="allFullConservationFees"
                        item-text="payment_person"
                        item-value="payment_public_id"
                        :return-object="true"
                        :loading="$loadingTrue"
                        class="futuristic-input"
                      ></v-autocomplete>
                      <v-autocomplete
                        label="Select Currency"
                        v-model="group.currency"
                        :items="allCurrencies"
                        :rules="[(v) => !!v || 'Item is required']"
                        required
                        item-text="currency_name"
                        item-value="currency_public_id"
                        :loading="$loadingTrue"
                        class="futuristic-input"
                      ></v-autocomplete>
                      <v-text-field
                        label="Amount"
                        type="number"
                        v-model="group.amount"
                        :rules="requiredRules"
                        required
                        class="futuristic-input"
                      ></v-text-field>
                    </v-form>
                    <v-btn
                      :depressed="true"
                      block
                      color="primary"
                      type="submit"
                      @click.prevent="addConservationFeeGroup()"
                      v-if="edit === false"
                      class="futuristic-btn"
                    >Add Fee</v-btn>
                  </v-container>
                </v-card>
              </v-container>
              <v-container>
                <v-card flat class="futuristic-card">
                  <div class="card-header">
                    <h4 class="earth-color">CONSERVATION ENTRY FEE SCHEDULE</h4>
                    <div class="title-decoration"></div>
                  </div>
                  <v-card-text>
                    <p>
                      <b>Start Date:</b>
                      <span v-if="conservation_fee.start_date">
                        {{ $moment(conservation_fee.start_date).format("Do MMMM YYYY") }}
                      </span>
                    </p>
                    <p>
                      <b>End Date:</b>
                      <span v-if="conservation_fee.end_date">
                        {{ $moment(conservation_fee.end_date).format("Do MMMM YYYY") }}
                      </span>
                    </p>
                    <p>
                      <b>Destination:</b>
                      {{ conservation_fee.destination_details.destination_name }}
                    </p>
                    <table class="table table-bordered futuristic-table">
                      <tr>
                        <td>Residency</td>
                        <td>Amount</td>
                      </tr>
                      <tr v-for="(fee, key) in conservation_fee.fees" :key="key">
                        <td>{{ fee.person_details }}</td>
                        <td
                          v-if="fee.currency === '162fface-f5f1-41de-913b-d2bb784dda3a'"
                        >
                          KES {{ fee.amount }}
                        </td>
                        <td
                          v-if="fee.currency === '6bf74e49-7ff6-4555-a080-15541d62204a'"
                        >
                          USD {{ fee.amount }}
                        </td>
                      </tr>
                    </table>
                    <div class="action-buttons">
                      <v-btn
                        :depressed="true"
                        color="error"
                        type="submit"
                        @click.prevent="resetSchedule()"
                        v-if="edit === false && conservation_fee.fees.length > 0"
                        class="futuristic-btn error-btn"
                      >Reset Schedule</v-btn>
                      <v-btn
                        :depressed="true"
                        color="info"
                        type="submit"
                        @click.prevent="postConservationFee()"
                        v-if="edit === false && conservation_fee.fees.length > 0"
                        class="futuristic-btn info-btn"
                      >Post Schedule</v-btn>
                    </div>
                  </v-card-text>
                </v-card>
              </v-container>
            </v-flex>
            <v-flex lg8>
              <v-container>
                <v-card class="futuristic-card">
                  <div class="card-header">
                    <h4 class="earth-color">CONSERVATION FEES</h4>
                    <div class="title-decoration"></div>
                  </div>
                  <v-data-table
                    :headers="columns"
                    :items="allFullConservationSchedule"
                    :search="search"
                    :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
                    :disable-initial-sort="true"
                    :loading="$loadingTrue"
                    class="futuristic-table"
                  >
                    <v-progress-linear
                      slot="progress"
                      color="#587e27"
                      indeterminate
                      height="3"
                    ></v-progress-linear>
                    <template slot="items" slot-scope="props">
                      <td class="fancy">
                        {{ formated_date(props.item.schedule_start_date) }} -
                        {{ formated_date(props.item.schedule_end_date) }}
                      </td>
                      <td class="fancy">{{ props.item.schedule_destination }}</td>
                      <v-data-table
                        :headers="scheduleColumns"
                        :items="props.item.fees"
                        :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
                        :disable-initial-sort="true"
                        :loading="$loadingTrue"
                        class="futuristic-table"
                      >
                        <template slot="items" slot-scope="data">
                          <td class="fancy">{{ data.item.payment_currency }} {{ data.item.payment_price }}</td>
                          <td class="fancy">{{ data.item.payment_person }}</td>
                          <td class="fancy">
                            <v-btn
                              :depressed="true"
                              small
                              color="warning"
                              @click="editPricedSchedule(data.item)"
                              v-if="pricedSchedule === false"
                              class="futuristic-btn warning-btn action-btn"
                            >Edit</v-btn>
                            <v-btn
                              :depressed="true"
                              small
                              color="warning"
                              @click="cancelEditPricedSchedule()"
                              v-if="pricedSchedule === true"
                              class="futuristic-btn warning-btn action-btn"
                            >Cancel Edit</v-btn>
                          </td>
                        </template>
                      </v-data-table>
                      <td class="has-text-right">
                        <v-btn
                          :depressed="true"
                          small
                          color="warning"
                          @click="editConservationSchedule(props.item)"
                          v-if="pricedConservationSchedule === false"
                          class="futuristic-btn warning-btn action-btn"
                        >Edit</v-btn>
                        <v-btn
                          :depressed="true"
                          small
                          color="error"
                          @click="deleteConservationSchedule(props.item)"
                          v-if="pricedConservationSchedule === false"
                          class="futuristic-btn error-btn action-btn"
                        >Disable</v-btn>
                        <v-btn
                          :depressed="true"
                          small
                          color="error"
                          @click="cancelScheduleEdit()"
                          v-if="pricedConservationSchedule === true"
                          class="futuristic-btn error-btn action-btn"
                        >Cancel Edit</v-btn>
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-container>
            </v-flex>
          </div>
        </v-tab-item>
      </v-tabs>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "conservancy-fees",
  data() {
    return {
      localSchedule: localStorage.getItem("localSchedule"),
      start_date: this.$moment().format("YYYY-MM-DD"),
      menu1: false,
      modal1: false,
      menu2: false,
      modal2: false,
      pricedSchedule: false,
      pricedConservationSchedule: false,
      requiredRules: [(v) => !!v || "This field is required"],
      search: "",
      edit: false,
      columns: [
        { text: "Schedule Duration", value: "" },
        { text: "Schedule Destination", value: "schedule_destination" },
        { text: "" },
        { text: "Action" },
      ],
      localScheduleColumns: [
        { text: "Amount", value: "payment_currency" },
        { text: "Residency", value: "payment_person" },
      ],
      scheduleColumns: [
        { text: "Amount", value: "payment_currency" },
        { text: "Residency", value: "payment_person" },
        { text: "Action", value: "" },
      ],
      residencyColumns: [
        { text: "Name", value: "" },
        { text: "Marker", value: "" },
        { text: "Appears In School", value: "" },
        { text: "Income Account Code", value: "" },
        { text: "Department Analysis Code", value: "" },
        { text: "Needs Proof?", value: "" },
        { text: "Action", value: "" },
      ],
      conservation_fee: {
        start_date: "",
        end_date: "",
        fees: [],
        destination: "",
        destination_details: {},
        session_id: localStorage.getItem("lkjhgfdsa"),
      },
      group: {
        payment_person: "",
        person_details: {},
        amount: 0,
        currency: "",
      },
      residency: {
        payment_id: "",
        person: "",
        description: "",
        marker: "",
        school: "",
        max_number: "",
        income_account_code: "",
        department_analysis_code: "",
        session_id: localStorage.getItem("lkjhgfdsa"),
        residency_proof: false,
      },
      update_: {
        price_id: "",
        amount: 0,
        currency: "",
      },
      scheduleUpdate: {
        schedule_id: "",
        start_date: "",
        end_date: "",
        destination: "",
        session_id: localStorage.getItem("lkjhgfdsa"),
      },
    };
  },
  created() {
    this.$store.dispatch("get_full_conservation_fees");
    this.$store.dispatch("get_all_currencies");
    this.$store.dispatch("get_all_destinations");
    this.$store.dispatch("get_all_conservation_schedule");
  },
  methods: {
    resetSchedule: function () {
      this.conservation_fee = {
        start_date: "",
        end_date: "",
        fees: [],
        destination: "",
        destination_details: {},
        session_id: localStorage.getItem("lkjhgfdsa"),
      };
    },
    postConservationFee: function () {
      var instance = this;
      if (this.edit === false) {
        this.$store
          .dispatch("post_conservation_fee_schedule", this.conservation_fee)
          .then(function () {
            instance.cancelEdit();
            instance.resetFee();
          });
      } else {
        this.$store
          .dispatch("update_conservation_fee", this.conservation_fee)
          .then(function () {
            instance.resetInputs();
          });
      }
    },
    postResidencyConf: function () {
      var instance = this;
      this.$store
        .dispatch("post_conservation_fee", this.residency)
        .then(function () {
          instance.cancelEdit();
        });
    },
    updateResidencyConf: function () {
      var instance = this;
      this.$store
        .dispatch("update_conservation_fee", this.residency)
        .then(function () {
          instance.cancelEdit();
        });
      this.edit = false;
    },
    addConservationFeeGroup: function () {
      let data = {
        amount: this.group.amount,
        currency: this.group.currency,
        payment_person: this.group.person_details.payment_public_id,
        person_details: this.group.person_details.payment_person,
      };
      this.conservation_fee.fees.push(data);
      this.resetFee();
    },
    editResidency: function (residency_) {
      this.residency.payment_id = residency_.payment_public_id;
      this.residency.person = residency_.payment_person;
      this.residency.description = residency_.description;
      this.residency.department_analysis_code = residency_.payment_person_dept_code;
      this.residency.income_account_code = residency_.payment_person_income_code;
      if (residency_.marker === "A" || residency_.marker === "Adult - A") {
        this.residency.marker = "Adult - A";
      } else if (residency_.marker === "C" || residency_.marker === "Child - C") {
        this.residency.marker = "Child - C";
      } else if (residency_.marker === "I" || residency_.marker === "Infant - I") {
        this.residency.marker = "Infant - I";
      }
      if (residency_.school === "Y") {
        this.residency.school = "Yes";
      } else if (residency_.school === "N") {
        this.residency.school = "No";
      }
      if (residency_.residency_proof === "Yes") {
        this.residency.residency_proof = true;
      } else {
        this.residency.residency_proof = false;
      }
      this.residency.max_number = residency_.max_number;
      this.edit = true;
    },
    editConservationFee: function (fee) {
      this.conservation_fee.start_date = fee.start_date;
      this.conservation_fee.end_date = fee.end_date;
      this.conservation_fee.destination = fee.destination;
      this.conservation_fee.person = fee.payment_person;
      this.conservation_fee.currency = fee.payment_person_currency_id;
      this.conservation_fee.amount = fee.payment_person_amount;
      if (fee.marker === "A" || fee.marker === "Adult - A") {
        this.conservation_fee.marker = "Adult - A";
      } else if (fee.marker === "C" || fee.marker === "Child - C") {
        this.conservation_fee.marker = "Child - C";
      } else if (fee.marker === "I" || fee.marker === "Infant - I") {
        this.conservation_fee.marker = "Infant - I";
      }
      if (fee.school === "Y") {
        this.conservation_fee.school = "Yes";
      } else if (fee.school === "N") {
        this.conservation_fee.school = "No";
      }
      this.conservation_fee.max_number = fee.max_number;
      this.conservation_fee.payment_id = fee.payment_public_id;
      this.conservation_fee.description = fee.payment_person_description;
      this.conservation_fee.income_account_code = fee.payment_person_income_code;
      this.conservation_fee.department_analysis_code = fee.payment_person_dept_code;
    },
    editPricedSchedule: function (pricing) {
      this.update_.price_id = pricing.price_public_id;
      this.update_.amount = pricing.payment_price;
      this.update_.currency = pricing.payment_currency_id;
      this.pricedSchedule = true;
    },
    postEditedPricingSchedule: function () {
      var data = {
        price_id: this.update_.price_id,
        currency: this.update_.currency,
        amount: this.update_.amount,
        session_id: localStorage.getItem("lkjhgfdsa"),
      };
      this.$store.dispatch("edit_conservation_schedule_pricing", data);
      this.pricedSchedule = false;
    },
    cancelEditPricedSchedule: function () {
      this.pricedSchedule = false;
    },
    deleteConservationFee: function (publicId) {
      var data = {
        payment_id: publicId,
        session_id: localStorage.getItem("lkjhgfdsa"),
      };
      this.$store.dispatch("delete_conservation_fee", data);
    },
    editConservationSchedule: function (schedule) {
      this.pricedConservationSchedule = true;
      this.scheduleUpdate.schedule_id = schedule.schedule_public_id;
      this.scheduleUpdate.destination = schedule.schedule_destination_id;
    },
    postEditedConservationSchedule: function () {
      var data = {
        schedule_id: this.scheduleUpdate.schedule_id,
        start_date: this.scheduleUpdate.start_date,
        end_date: this.scheduleUpdate.end_date,
        session_id: localStorage.getItem("lkjhgfdsa"),
        destination: this.scheduleUpdate.destination,
      };
      this.$store.dispatch("edit_conservation_schedule", data);
      this.pricedConservationSchedule = false;
    },
    deleteConservationSchedule: function (schedule) {
      var data = {
        schedule_id: schedule.schedule_public_id,
        session_id: localStorage.getItem("lkjhgfdsa"),
      };
      this.$store.dispatch("delete_conservation_schedule", data);
    },
    cancelScheduleEdit: function () {
      this.pricedConservationSchedule = false;
    },
    resetInputs: function () {
      this.edit = false;
      this.conservation_fee.person = "";
      this.conservation_fee.currency = "";
      this.conservation_fee.amount = "";
      this.conservation_fee.marker = "";
      this.conservation_fee.max_number = "";
      this.conservation_fee.description = "";
      this.conservation_fee.school = "";
      this.conservation_fee.type = "";
      this.conservation_fee.income_account_code = "";
      this.conservation_fee.department_analysis_code = "";
    },
    resetInputs2: function () {
      this.edit = false;
      this.residency.person = "";
      this.residency.marker = "";
      this.residency.max_number = "";
      this.residency.description = "";
      this.residency.school = "";
      this.residency.income_account_code = "";
      this.residency.department_analysis_code = "";
    },
    resetFee: function () {
      this.group = {
        payment_person: "",
        person_details: {},
        amount: "",
        currency: "",
      };
    },
  },
};
</script>

<style scoped>
/* Futuristic Container */
.payment-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.payment-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

/* Card Header */
.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 1.5rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

/* Futuristic Card */
.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  overflow: hidden;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

/* Futuristic Input */
.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
  transition: all 0.2s ease;
}

.futuristic-input >>> .v-input__slot:hover {
  background: #e8eaf6;
}

/* Futuristic Switch */
.futuristic-switch >>> .v-input--switch__thumb {
  background: #587e27;
}

.futuristic-switch >>> .v-input--switch__track {
  background: #e8eaf6;
}

/* Futuristic Button */
.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
  color: white !important;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.futuristic-btn.primary {
  background: linear-gradient(45deg, #587e27, #4caf50) !important;
}

.warning-btn {
  background: linear-gradient(45deg, #fbc531, #ffca28) !important;
}

.error-btn {
  background: linear-gradient(45deg, #e53935, #d81b60) !important;
}

.info-btn {
  background: linear-gradient(45deg, #2196f3, #42a5f5) !important;
}

.action-btn {
  margin: 4px 0;
}

/* Action Buttons Container */
.action-buttons {
  display: flex;
  gap: 12px;
  padding: 16px;
  background: #f5f7fa;
  border-radius: 0 0 8px 8px;
}

/* Futuristic Table */
.futuristic-table >>> thead tr th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa) !important;
  color: #587e27 !important;
  font-weight: 600;
  font-size: 14px;
}

.futuristic-table >>> tbody tr:nth-of-type(even) {
  background-color: #f9f9f9;
}

.futuristic-table >>> tbody tr:hover {
  background-color: #f0f4f8 !important;
}

.futuristic-table.table-bordered {
  border: 1px solid #e8eaf6;
}

.futuristic-table.table-bordered td,
.futuristic-table.table-bordered th {
  border: 1px solid #e8eaf6;
  padding: 8px;
}

/* Futuristic Tabs */
.futuristic-tabs >>> .v-tabs__bar {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  border-radius: 8px;
}

.futuristic-tabs >>> .v-tabs__item {
  font-weight: 500;
  text-transform: none;
  transition: all 0.2s ease;
}

.futuristic-tabs >>> .v-tabs__item:hover {
  background: #f0f4f8;
}

/* Futuristic Date Picker */
.futuristic-date-picker >>> .v-picker__title {
  background: linear-gradient(45deg, #587e27, #4caf50);
  color: white;
}

.futuristic-date-picker >>> .v-date-picker-table th {
  color: #587e27;
}

/* Responsive Adjustments */
@media (max-width: 960px) {
  .payment-container {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.25rem;
  }

  .action-buttons {
    flex-direction: column;
  }
}

@media (max-width: 600px) {
  .payment-container {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1rem;
  }
}
</style>